// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable property-disallowed-list -- DS Component definition */
.ComboboxTagList-module__Container__nM7Hf {
    display: contents;
    min-width: 0;
}

.ComboboxTagList-module__TagList__iLd7w {
    min-width: 0;
}

.ComboboxTagList-module__TagListItem__JjRNw {
    min-width: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `ComboboxTagList-module__Container__nM7Hf`,
	"TagList": `ComboboxTagList-module__TagList__iLd7w`,
	"TagListItem": `ComboboxTagList-module__TagListItem__JjRNw`
};
export default ___CSS_LOADER_EXPORT___;
